import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { PERM } from '@/constants/permissions';
import { NAV } from '@/constants/navigation';
import DashboardPage from '@/pages/DashboardPage';

/**
 * Index ("/") route element. Most users can see the Dashboard, so render it
 * directly when allowed. A user without dashboard.read (e.g. a menu-only
 * role) previously hit /forbidden on login with no way forward from there
 * (ForbiddenPage's only link is back to "/"). Instead, send them to the
 * first nav item -- in NAV's priority order -- they actually have
 * permission for, and only fall back to /forbidden if they have none at all.
 */
export function DefaultLandingRoute() {
  const permissions = useAuthStore((s) => s.permissions);

  if (permissions.has(PERM.DASHBOARD_READ)) {
    return <DashboardPage />;
  }

  const firstAccessible = NAV.find((item) => permissions.has(item.permission));
  return <Navigate to={firstAccessible?.href ?? '/forbidden'} replace />;
}
